<template>
  <div class="panel-admin-body dashboard-layout">
    <div class="d-flex title">
      <div class="pb-1 button-center"><modal-link modal-id="How to Use" :image-size="'large'" :content-list="pageContent"></modal-link>{{ title }}</div>
      <smart-center-link page="Dashboard Layout" location="Header" />
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <user-settings />
    <div class="dashboard-layout-border"></div>
    <dashboard-settings  :initial-user-id="initialUserId"/>
    <div class="dashboard-layout-border"></div>
  </div>
</template>
<script>
import ContentService from "../../services/content.service";
import ClientService from "../../services/client.service";
import UserService from "../../services/user.service";

import UserSettings from "../../components/UserSettings.vue";
import DashboardSettings from "../../components/DashboardSettings.vue";
import CompanyMixins from "../../mixins/CompanyMixins.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";

export default {
  name: "DashboardLayout",
  mixins: [
    CompanyMixins, ContentMixins
  ],
  components: {
    UserSettings,
    DashboardSettings
  },
  props: {},
  data() {
    return {
      title: "Dashboard Layout",
      pageNumber: 3,
      settings: [],
      initialUserId:  UserService.getUserId(),
    };
  },
  methods: {
    loadData: function(){}
  },
  created() {},
  mounted() {
    this.$root.setShowMenuIcon(true);    
  },
  computed: {},
  watch: {},
};
</script>
